import React, { Fragment, ReactNode } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import Slider from '@components/slider/Index';
import NextButton from '@components/slider/NextButton';
import PrevButton from '@components/slider/PrevButton';

interface ItemsTrayProps {
  platform: string;
  children: ReactNode;
  sliderWrapperCls?: string;
}
const ItemsTray = (props: ItemsTrayProps) => {
  const { platform, children, sliderWrapperCls = '' } = props;

  const SliderOptions: Record<string, any> = {};

  const showSlider = !(
    platform === 'mobile' ||
    platform === 'tablet' ||
    platform === 'smarttv'
  );

  if (showSlider) {
    SliderOptions['renderButtons'] = (
      scrollPrev: any,
      scrollNext: any,
      prevBtnEnabled: any,
      nextBtnEnabled: any,
    ) => (
      <Fragment>
        <PrevButton clickHandler={scrollPrev} isEndReached={prevBtnEnabled} />
        <NextButton clickHandler={scrollNext} isEndReached={nextBtnEnabled} />
      </Fragment>
    );
  } else {
    SliderOptions['renderButtons'] = () => <></>;
  }

  return (
    (showSlider && (
      <Slider
        sliderWrapperClasses={ivclass(
          'iv-ml-20 lg:iv-ml-[0] md:iv-ml-[0] sm:iv-ml-[0] ',
          sliderWrapperCls,
        )}
        childrenWrapperClass={ivclass('iv-justify-start')}
        {...SliderOptions}
      >
        {children}
      </Slider>
    )) || (
      <div
        className={ivclass(
          'iv-overflow-x-auto',
          'iv-flex',
          'iv-no-scroll-bar-container',
        )}
      >
        {children}
      </div>
    )
  );
};

export default ItemsTray;
